'use client';

import { useMutation } from '@tanstack/react-query';
import { WOOCOMMERCE_MUTATIONS } from '../../infrastructure/woocommerce/utils/queries';

export const useWoocommerceService = () => {
  const useCreateOrderMutation = () => {
    return useMutation(WOOCOMMERCE_MUTATIONS.createOrder());
  };

  return {
    useCreateOrderMutation,
  };
};
